export const DEACTIVATABLE_TYPES = {
  PRODUCT: 'Product',
  MODIFIER: 'Modifier'
};

export const SORT_KEYS = {
  POSITION: 'position'
};
